// extracted by mini-css-extract-plugin
export default {"card":"icon-card-module--card--A0hIz","title":"icon-card-module--title--01VzC","description":"icon-card-module--description--PaK-T","image":"icon-card-module--image--g3Jxj"};